export default "__VITE_ASSET__91311283__"